import type { CaseStatus } from '../api/types';

export const STATUS_COUNT = 8;
export const ALL_STATUSES: CaseStatus[] = [0, 1, 2, 3, 4, 5, 6, 7];
export const BOARD_STATUSES: CaseStatus[] = [0, 1, 2, 3, 4, 5, 6];
export const APPROVAL: CaseStatus = 3;

export type Tone = 'lab' | 'wait' | 'ship' | 'ok';

export const statusTone = (s: number): Tone =>
  s === APPROVAL ? 'wait' : s === 6 ? 'ship' : s === 7 ? 'ok' : 'lab';

/** Инициалы для аватара: «Игорь Савин» → «ИС». */
export const initials = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((x) => x[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
